import * as React from "react";
import type { SVGProps } from "react";

const FacilityBicycle = React.memo((props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    focusable="false"
    {...props}
  >
    <circle
      cx="15.8347"
      cy="12.5017"
      r="3.33472"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.83203 6.24887H8.33307"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.16406 12.5018H8.74931L14.1682 6.66602L7.49878 8.33338L4.16406 12.5018Z"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.74826 12.5016L6.66406 6.24902"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.8375 12.5012L13.7533 4.99805H12.0859"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.49801 12.5017C7.49989 14.0606 6.42279 15.4133 4.90311 15.7606C3.38342 16.1079 1.82567 15.3573 1.15023 13.9524C0.474781 12.5475 0.861433 10.8621 2.08174 9.89211C3.30204 8.92211 5.03117 8.92564 6.24749 9.90063"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
FacilityBicycle.displayName = "FacilityBicycle";

export default FacilityBicycle;
